<div class="ds-flex ds-flex-col">
  <div class="ds-rounded-lg ds-ml-2xl ds-max-w-[75%] ds-self-start">
    <button
      class="
        ds-button ds-button-secondary ds-w-full ds-small ds-min-h-[40px]
        !ds-mb-sm
      "
      (click)="onSelected(option.label)"
      *ngFor="let option of message.options"
    >
      {{ option.label }}
    </button>
  </div>
</div>
